import { Link } from 'gatsby';

import { links } from 'helpers';

export const NavLinks = ({ activeClass }: { activeClass: string }) => (
    <>
        {links.map(link => (
            <Link
                key={link.name}
                to={link.to}
                activeClassName={activeClass}
                partiallyActive={link.to === '/' ? false : true}>
                {link.name}
            </Link>
        ))}
    </>
);
